import React from "react";
const Contenu = ({ details }) => {
    return (React.createElement("div", { className: "detailsTab__content" },
        React.createElement("div", { className: "detailsTab__informations" },
            React.createElement("div", { className: "detailsTab__text" }, (details === null || details === void 0 ? void 0 : details.description) || 'Aucune description'))));
};
export default Contenu;
